"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _sortBy = _interopRequireDefault(require("transmute/sortBy"));

var formatPipelineId = function formatPipelineId(pipeline) {
  return String(pipeline.pipelineId);
};

var formatPipelineReference = function formatPipelineReference(pipeline) {
  return new _ReferenceRecord.default({
    id: formatPipelineId(pipeline),
    label: pipeline.label,
    referencedObject: (0, _immutable.fromJS)(pipeline)
  });
};

var getDisplayOrder = function getDisplayOrder(pipeline) {
  if (typeof pipeline.displayOrder === 'number') {
    return pipeline.displayOrder;
  } else {
    return -1;
  }
};

var sortByDisplayOrder = (0, _sortBy.default)(getDisplayOrder);

var formatPipelines = function formatPipelines(response) {
  var sortedPipelines = sortByDisplayOrder((0, _immutable.List)(response));
  return (0, _immutable.OrderedMap)(sortedPipelines.map(function (pipeline) {
    return [formatPipelineId(pipeline), formatPipelineReference(pipeline)];
  }));
};

var _default = formatPipelines;
exports.default = _default;
module.exports = exports.default;